import React from "react";
import cubeImg from "../../Assets/image/cube.png";

const CubeIndoor = () => {
  return (
    <div className="w-full bg-white py-16">
      <div className="max-w-7xl mx-auto px-6">

        {/* TOP SECTION */}
        <div className="grid md:grid-cols-2 gap-12 items-center">

          {/* Image */}
          <div>
            <img
              src={cubeImg}
              alt="Cube LED Video Display"
              className="w-full rounded-2xl shadow-xl"
            />
          </div>

          {/* Content */}
          <div>
            <h1 className="text-4xl text-blue-700 font-bold mb-4">
             Beneicon LED Display Cube
            </h1>

            <p className="text-gray-600 mb-6 leading-relaxed">
              After public installations. Built using premium-grade LED modules and professional control systems, each unit is precision-engineered and performance-tested to ensure reliable operation and long service life in demanding environments.
            </p>

                      <a
  href="https://wa.me/+917065993135"
  target="_blank"
  rel="noopener noreferrer"
  className="bg-blue-600 text-white px-8 py-3 rounded-lg font-semibold hover:bg-purple-700 transition shadow-lg inline-block"
>Know More
</a>

            <div className="mt-6 text-sm text-gray-500">
              <p><span className="font-semibold text-black">Categories:</span> Cube LED Display, Trending</p>
              <p><span className="font-semibold text-black">Brand:</span> Beneicon</p>
            </div>
          </div>

        </div>

        {/* DESCRIPTION SECTION */}
        <div className="mt-20">

          <h2 className="text-3xl text-blue-700 font-bold mb-6">
            360° Immersive Visual Displays for Iconic Brand Experiences
          </h2>

          <p className="text-gray-700 leading-relaxed mb-6">Beneicon LED Display Cube, manufactured by Beneicon Pixel LLP, is a premium multi-side LED
display solution designed for high-impact branding, advertising, and creative installations. 
          </p>

          <p className="text-gray-700 leading-relaxed mb-6">
            Available
in both indoor and outdoor pixel pitch options, this cube display delivers seamless visuals from
multiple viewing angles, making it ideal for retail spaces, exhibitions, malls, showrooms, and public
environments. 
          </p>

          <p className="text-gray-700 leading-relaxed">
         Built using high-quality LED modules and professional control systems, each cube is
precision-engineered and performance-tested to ensure stable operation, uniform brightness, and
long service life. The modular structure allows flexible cube dimensions and multiple-side
configurations for dynamic visual presentation.
          </p>
        </div>

        {/* KEY FEATURES */}
        <div className="mt-20">
          <h2 className="text-3xl text-blue-700 font-bold mb-8">
            Key Features
          </h2>

          <ul className="space-y-4 text-gray-700">
            <li>• 360° Multi-Side Display – Engages audiences from all angles</li>
            <li>• Indoor & Outdoor Variants</li>
            <li>• High-Resolution LED Panels</li>
            <li>• Seamless Panel Integration</li>
            <li>• Flexible Content Control</li>
            <li>• Creative Installation Options</li>
            <li>• Energy Efficient & Reliable</li>
          </ul>
        </div>

        {/* TECHNICAL HIGHLIGHTS */}
        <div className="mt-20 bg-gray-50 p-10 rounded-2xl">
          <h2 className="text-3xl font-bold text-blue-700 mb-8">
            Technical Highlights
          </h2>

          <div className="grid md:grid-cols-2 gap-8 text-gray-700">

            <div>
               <h3 className="text-xl font-semibold mb-4">Indoor Applications</h3>
              <p><span className="font-semibold">Brand:</span> Beneicon</p>
<p><span className="font-semibold">Product:</span> Beneicon LED Display Cube</p>
<p><span className="font-semibold">Available Pixel Pitch Options:</span> P-2 / P-2.5</p>
<p><span className="font-semibold">Side Options:</span> 4 Side / 5 Side / 6 Side Display</p>
<p><span className="font-semibold">Brightness:</span> 500 – 800 nits</p>
<p><span className="font-semibold">Refresh Rate:</span> ≥ 3840 Hz</p>
<p><span className="font-semibold">Viewing Angle:</span> 140° (H) / 140° (V)</p>
<p><span className="font-semibold">Processing Depth:</span> 12 – 14 Bit</p>
<p><span className="font-semibold">Frame Rate:</span> 60 Hz</p>
<p><span className="font-semibold">Control System:</span> Plug & Play / Mobile Phone Content Control Supported</p>
<p><span className="font-semibold">Content Support:</span> 2K HD / 4K UHD</p>
<p><span className="font-semibold">Usage:</span> Indoor</p>
            </div>
                        <div>
                           <h3 className="text-xl font-semibold mb-4">Outdoor Applications</h3>
              <p><span className="font-semibold">Brand:</span> Beneicon</p>
<p><span className="font-semibold">Product:</span> Beneicon LED Display Cube</p>
<p><span className="font-semibold">Available Pixel Pitch Options:</span> P-3/ P-4</p>
<p><span className="font-semibold">Side Options:</span> 4 Side / 5 Side / 6 Side Display</p>
<p><span className="font-semibold">Brightness:</span> 4500 – 5500 nits</p>
<p><span className="font-semibold">Refresh Rate:</span> ≥ 3840 Hz</p>
<p><span className="font-semibold">Viewing Angle:</span> 140° (H) / 140° (V)</p>
<p><span className="font-semibold">Processing Depth:</span> 12 – 14 Bit</p>
<p><span className="font-semibold">Frame Rate:</span> 60 Hz</p>
<p><span className="font-semibold">Control System:</span> Plug & Play / Mobile Phone Content Control Supported</p>
<p><span className="font-semibold">Content Support:</span> 2K HD / 4K UHD</p>
<p><span className="font-semibold">Usage:</span> Outdoor</p>
            </div>


          </div>
        </div>

        {/* APPLICATIONS */}
        <div className="mt-20">

          <h2 className="text-3xl  text-blue-700 font-bold mb-8">
            Ideal Applications
          </h2>

          <div className="grid md:grid-cols-2 gap-12">

            <div>
              <h3 className="text-xl font-semibold mb-4">Indoor Applications</h3>
              <ul className="space-y-2 text-gray-700">
                <li>• Retail Showrooms & Experience Centers</li>
                <li>• Corporate Lobbies & Brand Zones</li>
                <li>• Shopping Malls & Atriums</li>
                <li>• Exhibitions & Trade Shows</li>
                <li>• Museums & Interactive Displays</li>
              </ul>
            </div>

            <div>
              <h3 className="text-xl font-semibold mb-4">Outdoor Applications</h3>
              <ul className="space-y-2 text-gray-700">
                <li>• Public Squares & City Installations</li>
                <li>• Outdoor Events & Festivals</li>
                <li>• Smart City & Landmark Displays</li>
                <li>• Commercial Advertising Zones</li>
                <li>• Theme Parks & Entertainment Areas</li>
              </ul>
            </div>

          </div>
        </div>


                      {/* FOOTER TAGLINE */}
        <div className="mt-20 text-center">
          <p className="text-lg font-semibold text-gray-800">
            <span className="text-blue-600 font-semibold">Beneicon</span> — Trust. Technology. Impact.
          </p>
        </div>

      </div>
    </div>
  );
};

export default CubeIndoor;